import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { WorkspaceServiceService } from '../../services/workspace-service.service';
import { GlobalGridModeService } from '../../services/globalGridMode/globalGridMode.service';
import { DataService } from '../../services/data/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsComponent } from '../alerts/alerts.component';
import { Alert } from '../../model/alert';
import { MobileMainView } from '../../enums/mobile-mainViews';

@Component({
  selector: 'mobile-alerts',
  template: require('./mobile-alerts.component.html'),
  styles: [require('./mobile-alerts.component.css')]
})
export class MobileAlertsComponent extends AlertsComponent {

  constructor(public workspaceService: WorkspaceServiceService, protected globalGridMode: GlobalGridModeService, protected dataService: DataService, public modalService: NgbModal) 
  {
    super(workspaceService, globalGridMode, dataService, modalService);
  }

  public newSymbol(event: MouseEvent, alert: Alert) {
    this.setAlertRead(alert);
    this.increment()
    event.stopPropagation();
    this.workspaceService.data.activeAlertId = this.workspaceService.data.openedAlertId = alert.Id;
    this.workspaceService.data.mobileView = MobileMainView.CHARTING;
    const chart = this.workspaceService.data.charts["ach1"].instance;
    if(chart != null) chart.onSelectNewSymbol(alert.CurrencyPair);
  }

  public initScroll()
  {
    
  }

  @Output('update')
  change: EventEmitter<boolean> = new EventEmitter<boolean>();

  public increment() {
    this.workspaceService.data.mobileView = MobileMainView.CHARTING;
    this.change.emit(true);
  }


  public get showLoaderComponent()
  {
    return this.workspaceService.data.showLoaderComponent;
  }


  public get showToolbar()
  {
    return this.workspaceService.data.alertsAccess
  }
  
}
